import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

const create = async (data: any): Promise<any | Error> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.post('./notificacao-climatica', data, {
			headers: {
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response;
		}

		return new Error('Erro ao criar novo notificação');
	} catch (error: any) {
		if (
			error.response &&
			error.response.data &&
			error.response.data.error &&
			error.response.data.message
		) {
			return new Error(error.response.data.message);
		} else {
			return new Error(
				(error as { message: string }).message ||
					'Erro ao criar novo notificação'
			);
		}
	}
};

const getNotifications = async (uuid: string): Promise<any | Error> => {
	await AuthService.verify();
	try {
		const token = await AuthService.getAccessToken();
		const response = await ApiBack.get(
			`./notificacoes-climaticas?uuid=${uuid}`,
			{
				headers: {
					Authorization: `${token}`,
				},
			}
		);
		if (response.data) {
			return response;
		}
		return new Error('Erro ao buscar notificações');
	} catch (error: any) {
		if (
			error.response &&
			error.response.data &&
			error.response.data.error &&
			error.response.data.message
		) {
			return new Error(error.response.data.message);
		} else {
			return new Error(
				(error as { message: string }).message || 'Erro ao buscar notificação'
			);
		}
	}
};

const deleteNotification = async (uuid: string): Promise<any | Error> => {
	await AuthService.verify();
	try {
		const token = await AuthService.getAccessToken();
		const response = await ApiBack.delete(
			`./notificacao-climatica?uuid=${uuid}`,
			{
				headers: {
					Authorization: `${token}`,
				},
			}
		);
		if (response.status === 200) {
			return response.data;
		}
		return new Error('Erro ao deletar notificação');
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			return new Error(error.response.data.message);
		} else {
			return new Error('Erro ao deletar notificação');
		}
	}
};

export const NotificacaoService = {
	create,
	getNotifications,
	deleteNotification,
};
